import {styled} from "@mui/material/styles"

export const StyledFacetsContainer = styled("div")`
    display: flex;
    min-width: 0;
    flex-direction: column;
    width: 13rem;
`
